import { HomePage } from '../../data/main_content'

import './Home.scss'
import previewVideo from '../../video/preview.mp4'
import videoImg from '../../img/video.png'


export default function Home() {

    return(

        <div className="container home__container">

            <div className="content home__container--content">
                <h1 className='content-title'>{HomePage.title}</h1>
                <p className='content-text'>{HomePage.paragraph_01}</p>
                <p className='content-text'>{HomePage.paragraph_02}</p>
            </div>

            <div className="home__container--video">
                <video
                  className="video--main"
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="auto"
                  poster={videoImg}
                >
                  <source src={previewVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
            </div>


        </div>

    )

}
